import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '@heroicons/vue/24/outline';
import { Component, toNative, Vue } from '@natureos/vue-facing-decorator';

import { anyToolDockExpanded, anyToolDockOpen } from '@/common/components/ui/map/tool-dock/tool-dock.component';
import { type Toast as ToastType } from '@/common/plugins/toast.plugin';

@Component({
  name: 'Toast',
  components: { CheckCircleIcon, XCircleIcon, ExclamationTriangleIcon, InformationCircleIcon },
})
class Toast extends Vue {
  public toasts: ToastType[] = [];

  public get isAuthRoute(): boolean {
    return this.$route.path.includes('/auth');
  }

  /**
   * Vertical placement class. We keep toasts at bottom-right so they
   * appear where users expect, but lift above any open `<ToolDock>` so
   * they're not visually obscured by the dock's white-tinted panel. The
   * expanded-dock case has to clear `max-h-[55vh]` of dock body + the
   * ~40px header; collapsed clears just the header. Auth routes have no
   * dock and no `--app-header-h` dashboard header, so stay top-5.
   */
  public get positionClass(): string {
    if (this.isAuthRoute) {return 'top-5';}
    if (anyToolDockExpanded.value) {return 'bottom-[62vh]';}
    if (anyToolDockOpen.value) {return 'bottom-15';}
    return 'bottom-5';
  }

  private mounted(): void {
    this.toasts = this.$toast.toasts;
  }

  public removeToast(id: number): void {
    this.$toast.removeToast(id);
  }
}

export default toNative(Toast);
export { default as Taost } from './toast.component.vue';
